
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/appManager/components/PendingApp/PendingApp.scss.css.virtualfile';
        module.exports = {"actionBtn":"_actionBtn_11j78_1"};